import {Component} from '@angular/core';
/**
 * \@title Basic menu
 */
export class MenuOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'menu-overview-example',
  templateUrl: 'menu-overview-example.html',
  styleUrls: ['menu-overview-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MenuOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
MenuOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MenuOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
